import React from 'react';
import { BaseIcon } from '../../base/BaseIcon';
import { IconProps } from '../../types';

export const HierInputCheckerIcon = React.memo<IconProps>(
  ({
    className = '',
    size = 24,
    color = 'currentColor',
    onClick,
    strokeWidth,
  }) => (
    <BaseIcon
      className={className}
      size={size}
      color={color}
      onClick={onClick}
      viewBox="0 0 24 24"
      strokeWidth={strokeWidth}
    >
      <path
        d="M22 0H11C10.45 0 10 0.45 10 1V4H6.5C5.95 4 5.5 4.45 5.5 5V8H2C1.45 8 1 8.45 1 9V23C1 23.55 1.45 24 2 24H13C13.55 24 14 23.55 14 23V20H17.5C18.05 20 18.5 19.55 18.5 19V16H22C22.55 16 23 15.55 23 15V1C23 0.45 22.55 0 22 0ZM12 22H3V10H12V22ZM16.5 18H14V9C14 8.45 13.55 8 13 8H7.5V6H16.5V18ZM21 14H18.5V5C18.5 4.45 18.05 4 17.5 4H12V2H21V14Z"
        fill={color}
      />
    </BaseIcon>
  ),
);

HierInputCheckerIcon.displayName = 'HierInputCheckerIcon';
